import { useRouteError } from 'react-router'
import { ErrorState } from '../../ui/primitives.tsx'
import styles from '../../ui/primitives.module.css'

/**
 * Last line of defence for a render that threw (ui-spec §7).
 *
 * Without an errorElement react-router unmounts the whole tree and the person gets a white page
 * with nothing to click — which is how a single bad field in one card took down the entire board.
 * Reload rather than a retry button: at this point the component state is gone, so there is nothing
 * left to retry into.
 *
 * The message itself is deliberately not shown. It is written by whatever threw — including the
 * server — and putting attacker-influenced text on screen is how a crash page becomes a phishing
 * surface. The detail goes to the console, where a developer can read it.
 */
export function RouteError(): React.JSX.Element {
  const error = useRouteError()
  console.error('Route error:', error)

  return (
    <div className={styles.errorPage}>
      <ErrorState
        text="Coś się posypało przy wyświetlaniu tego widoku. Odśwież stronę — jeśli wróci, zajrzyj do konsoli."
        retryLabel="Odśwież"
        onRetry={() => window.location.reload()}
      />
    </div>
  )
}
